import styles from "./styles.module.scss";
import { Tag } from "ui-kit-v2/src/tag/tag";
import { _ } from "i18n";
import { Tooltip } from "ui-kit-v2/src/tooltip/tooltip";
import { CoachReviewsCopyLinkButton } from "../../CopyLinkButton";
import { translatePosition } from "common/src/players-grid/utils";

interface CoachReviewsDisabledPlayerProps {
	eligibilityError: "no_user" | "no_player";
	rating: number | null;
	name: string;
	jerseyNumber: number | null;
	position: string | null;
}

export const CoachReviewsDisabledPlayer = ({ eligibilityError, rating, name, jerseyNumber, position }: CoachReviewsDisabledPlayerProps) => {
	const eligibilityTooltipLabel =
		eligibilityError === "no_user"
			? _("game.coachReviews.player.eligibility.noUser.tooltip")
			: _("game.coachReviews.player.eligibility.noPlayer.tooltip");

	return (
		<div className={styles["disabled-player"]}>
			<Tooltip
				label={eligibilityTooltipLabel}
				position="top"
				triggerClassName="w-full"
				tooltipClassName="max-w-[480px]"
				variant="dark"
				multiline
			>
				<div className={styles["disabled-player__header"]}>
					{rating !== null && (
						<Tag variant="secondary" palette={"neutral"}>
							{rating}
						</Tag>
					)}
					<p className={styles["disabled-player__name"]}>{name}</p>
					{jerseyNumber !== null && position !== null && (
						<Tag variant="outline" palette="neutral">
							#{jerseyNumber} {translatePosition(position)}
						</Tag>
					)}
				</div>
			</Tooltip>
			{eligibilityError === "no_user" && (
				<div className={styles["disabled-player__link"]}>
					<CoachReviewsCopyLinkButton lookAs="link" />
				</div>
			)}
		</div>
	);
};
